const url = {
  REQUEST_FOR_QUOTE: '/request-for-quote',
  RFQ_SEARCH: '/rfqsearch',
  MY_JOBS: '/myjobs',
  PO_SEARCH: '/purchaseordersearch',
  RAISE_CREDIT_NOTE: '/raisecreditnote',
};

export default url;
